import { render, staticRenderFns } from "./CandidateListAll.vue?vue&type=template&id=8bb72e4e&scoped=true&"
import script from "./CandidateListAll.vue?vue&type=script&lang=js&"
export * from "./CandidateListAll.vue?vue&type=script&lang=js&"
import style0 from "./CandidateListAll.vue?vue&type=style&index=0&id=8bb72e4e&lang=scss&scoped=true&"
import style1 from "./CandidateListAll.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb72e4e",
  null
  
)

export default component.exports